export const formatCurrency = (
  amount: number,
  maximumFractionDigits?: number
): string => {
  const dollar = Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
  });
  return dollar.format(Math.abs(amount));
};
